<template lang="pug">
v-slide-y-transition(mode="out-in")
  v-container(fluid)

    confirm(ref="deleteConfirm")
    confirm(ref="toggleVisibilityConfirm")

    v-toolbar.mb-3(dark, color="primary")
      v-text-field(append-icon="search", label="Filtrar", single-line, hide-details, v-model="search")
      v-btn(text, to="/accommodations/create") Añadir nuevo alojamiento

    v-alert(v-if="error", color="red") {{error}}

    v-data-table(:loading="loading", :headers="tableHeaders", :footer-props="{itemsPerPageOptions: rowsPerPage}", :items="accommodations", :search="search", class="elevation-1")
      template(v-slot:item.options="{ item }")
        v-btn(v-if="item.visible", @click="handleToggleVisibility(item)" text, icon, color="success")
          v-icon visibility
        v-btn(v-else, text, @click="handleToggleVisibility(item)" icon, color="warning")
          v-icon visibility_off
        v-btn(:to="`/accommodations/${item.id}/edit`", text, icon, color="primary", class="ml-4")
          v-icon edit
        v-btn(:to="`/accommodations/${item.id}/images`", text, icon, color="orange")
          v-icon photo
        v-btn(:to="`/accommodations/${item.id}/rooms`", text, icon, color="green")
          v-icon home
        v-btn(@click="handleDelete(item)", text, icon, color="red")
          v-icon delete
</template>

<style scoped>
.loader {
  text-align: center;
  padding: 20px 0;
}
</style>

<script>
module.exports = {
  data() {
    return {
      rowsPerPage: [25, 50, 100, { text: "Todo", value: -1 }],
      loading: false,
      search: "",
      error: null,
      accommodations: [],
      tableHeaders: [
        {
          text: "Nombre del alojamiento",
          align: "left",
          sortable: true,
          value: "name",
        },
        {
          text: "Provincia",
          align: "left",
          sortable: true,
          value: "state",
        },
        {
          text: "Opciones",
          align: "right",
          sortable: false,
          value: "options",
        },
      ],
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      api
        .get("/accommodations")
        .then((res) => {
          this.accommodations = res.data;
        })
        .catch((err) => {
          // eslint-disable-next-line no-console
          console.error(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleToggleVisibility(item) {
      this.$refs.toggleVisibilityConfirm
        .open(item.visible ? "Ocultar" : "Publicar", "¿Estás seguro?")
        .then((confirm) => {
          if (confirm) {
            this.loading = true;
            item.visible = !item.visible;
            api
              .put(`/accommodations/${item.id}`, item)
              .catch(this.handleError)
              .finally(() => {
                this.loading = false;
              });
          }
        });
    },
    handleDelete(item) {
      this.$refs.deleteConfirm
        .open("Eliminar", "¿Estás seguro?")
        .then((confirm) => {
          if (confirm) {
            api
              .delete(`/accommodations/${item.id}`)
              .then(() => {
                this.accommodations.splice(
                  this.accommodations.indexOf(item),
                  1
                );
              })
              .catch(this.handleError);
          }
        });
    },
    handleError(err) {
      this.error = err.message;
      // eslint-disable-next-line no-console
      console.error(err);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/Accommodations/Accommodations.vue